import type { FC } from 'react'

interface RichTextProps {
    htmlText: string | undefined
    className?: string
}

export const RichText: FC<RichTextProps> = props => {
    if (!props.htmlText) return null
    return <div className={`rich-text ${props.className}`} dangerouslySetInnerHTML={{ __html: props.htmlText }} />
}
